import React from "react";
import { Result, Button, Row, Col, Card, Layout } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

function LockedPage() {
  const navigate = useNavigate();
  const { Content } = Layout;

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Row gutter={[0, 0]}>
          <Col md={24}>
            <Card align="middle">
              <Result
                status="403"
                title="Access Locked"
                subTitle="This page is disabled by administrator."
                icon={<LockOutlined />}
                extra={
                  <Button type="primary" onClick={() => navigate(-1)}>
                    Go Back
                  </Button>
                }
              />
            </Card>
          </Col>
        </Row>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default LockedPage;
